import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    signal,
    SimpleChanges,
    TemplateRef,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import { GridListItem, GridsService } from "../../services/grids.service";
import { Grid } from "../s25-virtual-grid/s25.virtual.grid.component";
import { ScheduleOnlyGrid } from "./s25.academic.grids.util";
import { Bind } from "../../decorators/bind.decorator";
import { Item } from "../../pojo/Item";
import { TooltipResponse } from "../../services/tooltip.service";
import { DowGrid, S25DowGridComponent } from "../s25-virtual-grid/s25.dow.grid.component";
import { DropDownItem } from "../../pojo/DropDownItem";
import { S25AcademicGridsFilterComponent } from "./s25.academic.grids.filter.component";
import { S25Util } from "../../util/s25-util";
import { ModalConfig, S25ModalComponent } from "../s25-modal/s25.modal.component";
import { UserprefService } from "../../services/userpref.service";
import { Throttle } from "../../decorators/debounce.decorator";
import { AvailService, EventPerm } from "../../services/avail.service";
import { Flavor } from "../../pojo/Util";
import { PreferenceService } from "../../services/preference.service";
import { S25DatetimePrefssUtil } from "../s25-datetime-prefs/s25.datetime.prefs.util";
import { AriaLive } from "../../services/aria.live.service";
import createFilter = ScheduleOnlyGrid.createFilter;
import { Sheet, SpreadSheetService } from "../s25-spreadsheet/spreadsheet.service";
import { EventMicroService } from "../../services/event.micro.service";
import { EventMircotI } from "../s25-event/EventMicroI";
import { RecordType } from "../s25-event/ProfileI";
import { AvailCheckResult, SpaceAvailCheck, SpaceService } from "../../services/space.service";
import { ResourceAvailCheck, ResourceService } from "../../services/resource.service";
import { FlsService } from "../../services/fls.service";
import { hasFullFls } from "../../pojo/Fls";
import { Conflict } from "../s25-conflicts/s25.conflicts.component";
import { AvailWSResponse } from "../../services/resource.space.avail.service";
import WSSpacesAvail = AvailWSResponse.WSSpacesAvail;
import WSResourcesAvail = AvailWSResponse.WSResourcesAvail;
import { Proto } from "../../pojo/Proto";
import ResultObj = Proto.ResultObj;
import WSSpaceAvail = AvailWSResponse.WSSpaceAvail;
import WSResourceAvail = AvailWSResponse.WSResourceAvail;
import { ReservationService } from "../../services/reservation.service";
import { StandardSchedule } from "../../services/standard.schedule.service";
import { BOARD_CONST } from "../s25-swarm-schedule/s25.board.const";
import { Security } from "../../pojo/Security";
import Perms = Security.Perms;

@Component({
    selector: "s25-ng-schedule-only-grid",
    template: `
        <h2 class="grid-name ngCenter">{{ grid.name }}</h2>
        @if (!prefs) {
            <s25-ng-loading-inline-static />
        } @else {
            <s25-ng-dow-pattern-grid
                [dataSource]="dowGridDataSource"
                [dows]="BOARD_CONST.allDows"
                (visibleDowsChange)="applyFilters()"
                [startHour]="prefs.startHour"
                [endHour]="prefs.endHour"
                [canDragX]="editable"
                [canDragY]="false"
                [hasRefresh]="false"
                [hasUndo]="editable"
                [allowOverlap]="true"
                [displayShadows]="false"
                [hasMinimap]="true"
                [pollForChanges]="false"
                [hasStandardSchedule]="true"
                [standardSchedule]="grid.defaultSchedule ? { itemId: grid.defaultSchedule } : null"
                [selectedSchedule]="defaultSchedule"
                [hasSnapToStandardSchedules]="true"
                [snapToStandardSchedules]="true"
                [optionsLeftTemplate]="optionsLeft"
                [optionsRightTemplate]="optionsRight"
                [optionsBelowTemplate]="optionsBelow"
                [rowHeaderTemplate]="rowHeaderTemplate"
                [itemTemplate]="itemTemplate"
                [spanHours]="3"
                [findOverlap]="true"
                [createOverlapItems]="true"
                [resizeOnDowChange]="true"
            ></s25-ng-dow-pattern-grid>
        }

        <ng-template #optionsLeft let-defaultOptions="defaultOptions">
            <button class="aw-button aw-button--danger--outline exit" (click)="exit.emit()">Exit</button>
            @if (grid.isOwner) {
                <s25-ng-button [type]="'outline'" (click)="shareModal.open()">Share</s25-ng-button>
            }
            <ng-container [ngTemplateOutlet]="defaultOptions"></ng-container>
        </ng-template>

        <ng-template #optionsRight let-defaultOptions="defaultOptions">
            @if (isLoading()) {
                <s25-ng-loading-inline-static [text]="'Saving...'" />
            }
            <ng-container [ngTemplateOutlet]="defaultOptions"></ng-container>
            <s25-popover [popoverTemplate]="legend" [openTrigger]="'click'" [closeTrigger]="'click'">
                <s25-ng-button [type]="'outline'" [replaceClickEvent]="false" class="legend">Legend</s25-ng-button>
            </s25-popover>
            <ng-template #legend>
                <s25-ng-academic-grids-legend [showLocResConflicts]="false" />
            </ng-template>
            <s25-ng-button [type]="'danger--outline'" [onClick]="checkConflicts">Check Conflicts</s25-ng-button>
            @if (saveType === "bulk") {
                <s25-ng-button [type]="'primary'" [onClick]="save">Apply Changes</s25-ng-button>
            }
        </ng-template>

        <ng-template #optionsBelow let-defaultOptions="defaultOptions">
            <div class="optionsBelow">
                <div class="left">
                    <s25-ng-select [(selected)]="mode" (selectedChange)="onModeChange()" [options]="modeOptions" />
                    @if (editable) {
                        <s25-ng-select [(selected)]="conflictAction" [options]="conflictActionOptions" />
                    }
                </div>
                <div class="right">
                    <div class="activeFilters">
                        @for (filter of filters; track filter.label) {
                            @if (filter.active() && (filter.showText?.() ?? true) && filter.type !== "none") {
                                <div class="activeFilter">
                                    <s25-ng-button [type]="'none'" (click)="clearFilter(filter)">
                                        <s25-ng-icon [type]="'close'" />
                                    </s25-ng-button>
                                    <span>{{ filter.label }}: </span>
                                    <span [title]="filter.text()">{{ filter.text() }}</span>
                                </div>
                            }
                        }
                    </div>

                    <div class="filtersWrapper" s25-ng-click-outside (clickOutside)="toggleFilters(false)">
                        <button class="aw-button aw-button--outline toggle-filters" (click)="toggleFilters()">
                            <s25-ng-icon [type]="showFilters ? 'caretUp' : 'caretDown'"></s25-ng-icon>
                            Filters
                        </button>
                        @if (showFilters) {
                            <s25-ng-academic-grids-filter
                                [filters]="filters"
                                (apply)="applyFilters()"
                                (clear)="applyFilters()"
                            />
                        }
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #rowHeaderTemplate let-header="header">
            <div class="row-header">
                @if (mode === "standard") {
                    <s25-item-event
                        [modelBean]="{ itemId: header.data.eventId, itemName: header.data.header }"
                        [newTab]="true"
                        [dataService]="eventTooltipService"
                        [dataServiceContext]="header"
                    />
                } @else if (mode === "instructor") {
                    <s25-item-contact
                        [modelBean]="{
                            itemId: header.data.instructor.id,
                            itemName: header.data.instructor.name,
                        }"
                        [newTab]="true"
                    />
                }
            </div>
        </ng-template>

        <ng-template #itemTemplate let-item="item" let-dragging="dragging" let-moving="moving">
            <s25-ng-schedule-only-grid-item
                [item]="item"
                [dragging]="dragging"
                [isDragging]="dragging?.items.has(item)"
                [moving]="moving"
                (bringToFront)="bringToFront($event)"
            />
        </ng-template>

        <ng-template #overlappingItems let-item="item">
            <ul class="overlapInfo">
                <li>
                    <s25-ng-button [type]="'link'" (click)="bringToFront(item)" [title]="'Bring To Front'">
                        {{ item.data.eventName }}
                    </s25-ng-button>
                </li>
                @for (overlapItem of item.overlapping; track overlapItem.id) {
                    <li>
                        <s25-ng-button [type]="'link'" (click)="bringToFront(overlapItem)" [title]="'Bring To Front'">
                            {{ overlapItem.data.eventName }}
                        </s25-ng-button>
                    </li>
                }
            </ul>
        </ng-template>

        <ng-template #conflictsCollapse let-conflicts="conflicts" let-type="type" let-open="open">
            @if (!!conflicts.length) {
                <s25-simple-collapse
                    class="conflicts"
                    [attr.data-type]="type"
                    [headerText]="conflicts.length + ' ' + type | pluralS: conflicts.length"
                    [defaultCollapsed]="!open"
                >
                    @for (c of conflicts; track c) {
                        <ng-container *ngTemplateOutlet="conflict; context: { conflict: c }" />
                    }
                </s25-simple-collapse>
            }
        </ng-template>

        <ng-template #conflict let-conflict="conflict">
            @if (conflict.type === "instructor") {
                <div class="conflict instructorConflict">
                    <label>Instructor:</label>
                    <span>{{ conflict.item.data.instructor.name }}</span>
                    <label>Meeting Pattern:</label>
                    <span>{{ conflict.item.data.dow }}</span>
                    <label>Time:</label>
                    <span>{{ conflict.time }}</span>
                    <label>Sections:</label>
                    <ul>
                        @for (item of conflict.items; track item.id) {
                            <li>{{ item.data.eventName }}</li>
                        }
                    </ul>
                </div>
            } @else if (conflict.type === "locationAvailability" || conflict.type === "resourceAvailability") {
                <div class="conflict availabilityConflict">
                    <label>Meeting Pattern:</label>
                    <span>{{ conflict.item.data.dow }}</span>
                    <label>Time:</label>
                    <span>{{ conflict.time }}</span>
                    <label>Section:</label>
                    <span>{{ conflict.item.data.eventName }}</span>
                    <s25-ng-conflicts [collapsible]="true" [onOpen]="conflict.load" />
                </div>
            } @else if (conflict.type === "saveMessage" || conflict.type === "saveError") {
                <div class="conflict saveConflict">
                    <label>Meeting Pattern:</label>
                    <span>{{ conflict.item.data.dow }}</span>
                    <label>Time:</label>
                    <span>{{ conflict.time }}</span>
                    <label>Section:</label>
                    <span>{{ conflict.item.data.eventName }}</span>
                    @if (conflict.type === "saveError") {
                        <label>Summary:</label>
                        <span>{{ conflict.message }}</span>
                    }
                    <label>Messages:</label>
                    <ul class="bullets">
                        @for (message of conflict.messages; track message) {
                            <li>{{ message }}</li>
                        }
                    </ul>
                </div>
            }
        </ng-template>

        <s25-ng-modal #conflictsModal [title]="'Conflicts'" [size]="'sm'">
            <ng-template #s25ModalBody>
                @if (conflicts.total === 0) {
                    <p>There are no outstanding conflicts.</p>
                } @else {
                    <p>
                        There {{ conflicts.total === 1 ? "is" : "are" }} {{ conflicts.total }} outstanding
                        {{ "conflict" | pluralS: conflicts.total }}.
                    </p>
                    <ng-container
                        [ngTemplateOutlet]="conflictsCollapse"
                        [ngTemplateOutletContext]="{
                            conflicts: conflicts.instructors,
                            type: 'Instructor Conflict',
                            open: conflicts.types === 1,
                        }"
                    />
                    <ng-container
                        [ngTemplateOutlet]="conflictsCollapse"
                        [ngTemplateOutletContext]="{
                            conflicts: conflicts.locations,
                            type: 'Location Conflict',
                            open: conflicts.types === 1,
                        }"
                    />
                    <ng-container
                        [ngTemplateOutlet]="conflictsCollapse"
                        [ngTemplateOutletContext]="{
                            conflicts: conflicts.resources,
                            type: 'Resource Conflict',
                            open: conflicts.types === 1,
                        }"
                    />
                }
            </ng-template>
            <ng-template #s25ModalFooter>
                <div style="display: flex; justify-content: end; gap: 0.5rem">
                    @if (conflicts.total > 0) {
                        <s25-ng-button [type]="'outline'" [title]="'Download as Excel'" [onClick]="downloadConflicts">
                            <s25-ng-icon [type]="'excel'" [label]="'Download as Excel'" />
                        </s25-ng-button>
                    }
                    <s25-ng-button [type]="'primary'" (click)="conflictsModal.close()">Ok</s25-ng-button>
                </div>
            </ng-template>
        </s25-ng-modal>

        <s25-ng-modal #shareModal [title]="'Share Grid'" [size]="'xs'">
            <ng-template #s25ModalBody>
                <s25-ng-share-academic-grid
                    [id]="grid.id"
                    [(sharedWith)]="grid.sharedWith"
                    (saved)="shareModal.close()"
                    (cancelled)="shareModal.close()"
                />
            </ng-template>
        </s25-ng-modal>

        <s25-ng-modal #confirmConflictsModal [title]="'Conflicts'" [type]="'confirm'" [size]="'xs'">
            <ng-template #s25ModalBody let-conflicts="conflicts" let-action="action">
                <div class="confirmation">
                    <p>This action would create {{ conflicts.total }} {{ "conflict" | pluralS: conflicts.total }}.</p>
                    @if (action === "confirm") {
                        <p class="ngBold">Do you wish to continue?</p>
                    }
                    @if (action === "acknowledge") {
                        <p class="ngBold">Item will be returned to its original position</p>
                    }
                    <ng-container
                        [ngTemplateOutlet]="conflictsCollapse"
                        [ngTemplateOutletContext]="{
                            conflicts: conflicts.instructors,
                            type: 'Instructor Conflict',
                            open: conflicts.types === 1,
                        }"
                    />
                    <ng-container
                        [ngTemplateOutlet]="conflictsCollapse"
                        [ngTemplateOutletContext]="{
                            conflicts: conflicts.locations,
                            type: 'Location Conflict',
                            open: conflicts.types === 1,
                        }"
                    />
                    <ng-container
                        [ngTemplateOutlet]="conflictsCollapse"
                        [ngTemplateOutletContext]="{
                            conflicts: conflicts.resources,
                            type: 'Resource Conflict',
                            open: conflicts.types === 1,
                        }"
                    />
                </div>
            </ng-template>
        </s25-ng-modal>

        <s25-ng-modal #saveMessagesModal [type]="'acknowledge'" [size]="'xs'">
            <ng-template #s25ModalBody let-messages="messages" let-errors="errors">
                <ng-container
                    [ngTemplateOutlet]="conflictsCollapse"
                    [ngTemplateOutletContext]="{
                        conflicts: messages,
                        type: 'Warning',
                        open: !errors?.length,
                    }"
                />
                <ng-container
                    [ngTemplateOutlet]="conflictsCollapse"
                    [ngTemplateOutletContext]="{
                        conflicts: errors,
                        type: 'Error',
                        open: !messages?.length,
                    }"
                />
            </ng-template>
        </s25-ng-modal>
    `,
    styles: `
        :host {
            --item-border-color: #333;
            --item-border: 1px solid var(--item-border-color);
            --item-shadow-background: #616161;
            --column-width: 50px;
        }

        ::ng-deep .nm-party--on s25-ng-schedule-only-grid {
            --item-border-color: #000;
        }

        .optionsBelow {
            display: flex;
            justify-content: space-between;
            gap: 0.5rem;
            padding-block-end: 0.5rem;
        }

        .optionsBelow .left {
            display: flex;
            justify-content: start;
            gap: 0.5rem;
        }

        .optionsBelow .right {
            display: flex;
            justify-content: end;
            gap: 0.5rem;
        }

        .filtersWrapper {
            position: relative;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }

        .activeFilters {
            display: flex;
            justify-content: right;
            gap: 0.5rem;
            flex-wrap: wrap-reverse;
            padding-bottom: 0.5rem;
        }

        .activeFilter {
            font-size: 0.8em;
            border-radius: 1em;
            padding: 0.1rem 0.4rem 0 0.2rem;
            background: var(--cn-blue);
            margin-bottom: -0.05em;
            max-width: 20em;
            text-overflow: ellipsis;
            text-wrap: nowrap;
            overflow: hidden;
            color: white;
            height: fit-content;
        }

        .activeFilter s25-ng-button {
            float: left;
            padding-top: 0.1em;
        }

        s25-ng-academic-grids-filter {
            position: absolute;
            z-index: 11;
            top: 100%;
            right: 0;
            margin-top: 0.5rem;
            border: 1px solid black;
        }

        .row-header {
            padding-inline-start: 0.5rem;
            cursor: pointer;
        }

        .conflict {
            display: grid;
            grid-template-columns: 10em auto;
            padding: 0.5em;
            border: 1px solid rgba(0, 0, 0, 0.2);
            background: color-mix(in lch, var(--collapse-color), #fff0 92%);
            margin-top: 1rem;
            border-radius: 3px;
            overflow-wrap: anywhere;
        }

        .conflict label {
            font-weight: bold;
        }

        .conflict ul {
            list-style: none;
            padding: 0;
            margin: 0;

            &.bullets {
                list-style: initial;
            }
        }

        .availabilityConflict s25-ng-conflicts {
            grid-column: 1/-1;
        }

        ::ng-deep s25-ng-schedule-only-grid .simple-collapse--wrapper {
            border: none;
            box-shadow: none;
            background: none !important;
        }

        ::ng-deep s25-ng-schedule-only-grid .simple-collapse--wrapper .c-sectionHead {
            border: 1px solid var(--border-color);
        }

        s25-simple-collapse.conflicts {
            &[data-type="Instructor Conflict"] {
                --collapse-color: #ba92e1;
            }

            &[data-type="Location Conflict"] {
                --collapse-color: #0077d7;
            }

            &[data-type="Resource Conflict"] {
                --collapse-color: #e91e63;
            }

            &[data-type="Warning"] {
                --collapse-color: #f79232;
            }

            &[data-type="Error"] {
                --collapse-color: var(--error-message-color);
            }
        }

        ::ng-deep s25-ng-schedule-only-grid s25-simple-collapse.conflicts > .simple-collapse--wrapper > .c-sectionHead {
            background: white !important;
            border-radius: 3px;
        }

        ::ng-deep
            s25-ng-schedule-only-grid
            s25-simple-collapse.conflicts
            > .simple-collapse--wrapper
            > .c-sectionHead::before {
            border-left: 0.25em solid var(--collapse-color);
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false,
})
export class S25ScheduleOnlyGridComponent implements OnInit, OnChanges {
    @Input({ required: true }) grid: GridListItem;
    @Input({ required: false }) editable: boolean;

    // Outputs
    @Output() exit = new EventEmitter<boolean>(); // Emitting will unload the component. Boolean indicates whether to refresh table in parent

    // Views
    @ViewChild(S25DowGridComponent) dowGridComponent: S25DowGridComponent<
        ScheduleOnlyGrid.HeaderData,
        ScheduleOnlyGrid.RowData,
        ScheduleOnlyGrid.ItemData
    >;
    @ViewChild("overlappingItems") overlappingItemsTemplate: TemplateRef<any>;
    @ViewChild("conflictsModal") conflictsModal: S25ModalComponent;
    @ViewChild("confirmConflictsModal") confirmConflictsModal: S25ModalComponent;
    @ViewChild("saveMessagesModal") saveMessagesModal: S25ModalComponent;

    // Variables
    prefs: Awaited<ReturnType<typeof GridsService.getPreferences>>;
    dowGridDataSource: ScheduleOnlyGrid.DataSource;
    showFilters: boolean = false;
    filters: ScheduleOnlyGrid.Filter[];
    mode: (typeof this.modeOptions)[number]["value"] = "standard";
    modeOptions = [
        { value: "standard", label: "Standard View" },
        { value: "instructor", label: "Instructor View" },
    ] as const;
    is24Hours: boolean;
    assignmentPolicy: { locations: Record<number, EventPerm>; resources: Record<number, EventPerm> };
    timezone: { instance: Flavor<string, "IANATimezone">; user: Flavor<string, "IANATimezone"> };
    conflictAction: (typeof this.conflictActionOptions)[number]["value"] = "warn";
    conflictActionOptions = [
        { value: "none", label: "Ignore Conflicts" },
        { value: "warn", label: "Warn on Conflicts" },
        { value: "prevent", label: "Prevent Conflicts" },
    ];
    conflicts: ScheduleOnlyGrid.Conflicts;
    saveType: "individual" | "bulk" = "individual"; // Bulk saving not fully implemented
    isLoading = signal(false);
    defaultSchedule: StandardSchedule[];
    protected readonly BOARD_CONST = BOARD_CONST;

    constructor(public cd: ChangeDetectorRef) {}

    ngOnChanges(changes: SimpleChanges) {
        if (
            changes.grid &&
            !changes.grid.firstChange &&
            changes.grid.previousValue?.id !== changes.grid.currentValue?.id
        ) {
            this.dowGridComponent.refresh();
        }
    }

    async ngOnInit() {
        this.dowGridDataSource = {
            getData: this.getGridData,
            afterRefresh: this.afterRefresh,
            onItemsPickedUp: this.onItemsPickedUp,
            onItemsDragged: this.onItemsDragged,
            onItemsPutDown: this.onItemsPutDown,
            afterItemsMoved: this.afterItemsMoved,
            onUndo: this.onUndo,
            onRedo: this.onRedo,
        };

        const [prefs, is24Hours, instanceTz, userTz] = await Promise.all([
            GridsService.getPreferences(),
            UserprefService.getIs24HourTime(),
            PreferenceService.getPreferences(["timezone"], "S"),
            UserprefService.getTZName(),
        ]);
        this.prefs = prefs;
        this.is24Hours = is24Hours;
        this.timezone = {
            instance: S25DatetimePrefssUtil.timeZoneToIANA[instanceTz?.timezone?.value || 25],
            user: userTz,
        };
        this.cd.detectChanges();
    }

    @Bind
    async getGridData(query: Grid.DataQuery): Promise<ScheduleOnlyGrid.Data> {
        const [gridResult] = await Promise.all([GridsService.getData(this.grid.id)]);
        const data = gridResult.data;
        if (gridResult.error) {
            alert("Something went wrong when fetching grid data");
            this.exit.emit();
            return;
        }

        const { rows, items } = ScheduleOnlyGrid.getData(data);

        this.filters = this.initFilters(rows);

        this.assignmentPolicy = { locations: data.spaceAp, resources: data.resourceAp };
        this.defaultSchedule = data.defaultSchedule;
        this.cd.detectChanges(); // Need to pass dows into DowGrid through template

        return { items, rows, message: rows.length === 0 && "No events in search" };
    }

    @Bind
    afterRefresh(gridItems: Grid.Item<ScheduleOnlyGrid.ItemData>[]) {
        const items: ScheduleOnlyGrid.Item[] = gridItems as unknown as ScheduleOnlyGrid.Item[];
        this.checkInstructorConflicts(items, true);
        this.applyFilters();
    }

    @Bind
    async onUndo(gridItems: Grid.Item<ScheduleOnlyGrid.ItemData>[]) {
        return await this.onItemsPutDown(gridItems);
    }

    @Bind
    async onRedo(gridItems: Grid.Item<ScheduleOnlyGrid.ItemData>[]) {
        return await this.onItemsPutDown(gridItems);
    }

    @Bind
    async eventTooltipService(
        itemType: Item.Id,
        eventId: number,
        reservationId: number,
        item: ScheduleOnlyGrid.Item,
    ): Promise<TooltipResponse> {
        const template = this.overlappingItemsTemplate;
        return ScheduleOnlyGrid.eventTooltipService(template, itemType, eventId, reservationId, item);
    }

    initFilters(rows: ScheduleOnlyGrid.Row[]) {
        const toItem = (id: number | string, name: string) => ({ itemId: id, itemName: name });

        const featureMap = new Map<number, DropDownItem>();
        const sectionTypeSet = new Set<string>();
        const instructorsMap = new Map<number, DropDownItem>();
        const subTermSet = new Set<string>();
        const subjectSet = new Set<string>();
        for (const row of rows) {
            for (const feature of row.data.features ?? []) {
                if (feature.name) featureMap.set(feature.id, toItem(feature.id, feature.name));
            }

            const instructor = row.data.instructor;
            if (instructor) {
                instructorsMap.set(instructor.id, toItem(instructor.id, instructor.name));
            }

            if (row.data.sectionType) sectionTypeSet.add(row.data.sectionType);
            if (row.data.subTerm) subTermSet.add(row.data.subTerm);
            if (row.data.subjectCode) subjectSet.add(row.data.subjectCode);
        }

        const features: DropDownItem[] = Array.from(featureMap.values());
        const instructors: DropDownItem[] = Array.from(instructorsMap.values());
        const sectionTypes: DropDownItem[] = Array.from(sectionTypeSet).map((s) => toItem(s, s));
        const subTerms: DropDownItem[] = Array.from(subTermSet).map((s) => toItem(s, s));
        const subjects: DropDownItem[] = Array.from(subjectSet).map((s) => toItem(s, s));
        const includes: DropDownItem[] = [
            { itemId: "isMakeupDate", itemName: "Makeup Dates" },
            { itemId: "isConversionDate", itemName: "Conversion Dates" },
            { itemId: "isExamDate", itemName: "Exams Dates" },
        ];

        for (const type of [features, sectionTypes, instructors, subTerms, subjects]) {
            type.sort((a, b) => a.itemName.localeCompare(b.itemName));
        }

        return [
            createFilter({ type: "text", label: "Name", transform: (row) => row.data.eventName }),
            createFilter({ type: "numberRange", label: "EHC", transform: (row) => row.data.expectedHeadCount }),
            createFilter({ type: "numberRange", label: "RHC", transform: (row) => row.data.registeredHeadCount }),
            createFilter({
                type: "dropdownMultiselect",
                label: "Feature",
                transform: (row) => row.data.features.map((req) => req.id),
                data: { items: features, placeholder: "Features" },
            }),
            createFilter({
                type: "dropdownMultiselect",
                label: "Instructor",
                transform: (row) => [row.data.instructor?.id],
                data: { items: instructors, placeholder: "Contacts" },
            }),
            createFilter({
                type: "dropdownMultiselect",
                label: "Section Type",
                transform: (row) => [row.data.sectionType],
                data: { items: sectionTypes, placeholder: "Section Types" },
            }),
            createFilter({
                type: "dropdownMultiselect",
                label: "Subject Code",
                transform: (row) => [row.data.subjectCode],
                data: { items: subjects, placeholder: "Subjects" },
            }),
            createFilter({
                type: "dropdownMultiselect",
                label: "Subterm",
                transform: (row) => [row.data.subTerm],
                data: { items: subTerms, placeholder: "Subterms" },
            }),
            createFilter({ type: "text", label: "CRN", transform: (row) => row.data.courseReferenceNumber }),
            createFilter({
                type: "options",
                label: "Include",
                transform: (item) => {
                    const { isMakeupDate, isConversionDate, isExamDate } = item.data;
                    const skip = !isMakeupDate && !isConversionDate && !isExamDate;
                    return { skip, isMakeupDate, isConversionDate, isExamDate };
                },
                data: { items: includes, placeholder: "Sections" },
            }),
            createFilter({ type: "yesNo", label: "Has Locations", transform: (row) => !!row.data.locations.length }),
            createFilter({
                type: "yesNo",
                label: "Has Conflicts",
                transform: (row) =>
                    !row.data._fitsSchedule() ||
                    row.data.instructorConflict() ||
                    row.data.locationConflict() ||
                    row.data.resourceConflict(),
            }),
            {
                type: "none",
                label: "Meeting Patterns",
                active: signal(true),
                filter: (item) => this.dowGridComponent.visibleDows.includes(item.data.dow),
            } satisfies ScheduleOnlyGrid.Filter,
        ];
    }

    toggleFilters(open?: boolean) {
        this.showFilters = open === undefined ? !this.showFilters : open;
        this.cd.detectChanges();
    }

    @Bind
    applyFilters() {
        if (!this.dowGridComponent.data) return;

        const rowsToKeep = new Set<number>();
        this.dowGridComponent.filterItems((item) => {
            const keep = this.filters.every((filter) => !filter.active() || filter.filter(item));
            if (keep) rowsToKeep.add(this.getFilterKey(item));
            return keep;
        }, false);
        this.dowGridComponent.filterRows((row) => {
            const key = this.getFilterKey(row);
            if (!key) return false;
            return rowsToKeep.has(key);
        });
        this.showFilters = false;
    }

    getFilterKey(item: ScheduleOnlyGrid.Item | ScheduleOnlyGrid.Row): number {
        if (this.mode === "standard") return item.data.profileId;
        if (this.mode === "instructor") return item.data.instructor?.id;
        return null;
    }

    @Bind
    clearFilters() {
        for (const filter of this.filters) S25AcademicGridsFilterComponent.clearFilter(filter);
        this.applyFilters();
    }

    clearFilter(filter: ScheduleOnlyGrid.Filter): void {
        S25AcademicGridsFilterComponent.clearFilter(filter);
        this.applyFilters();
    }

    onModeChange() {
        if (!this.dowGridComponent.data.items?.length) return;
        if (this.mode === "instructor") this.toInstructorMode();
        else if (this.mode === "standard") this.toStandardMode();
    }

    toInstructorMode() {
        this.dowGridComponent.clearItemFilter(false);
        this.dowGridComponent.clearRowFilter(false);
        const rows = this.dowGridComponent.allRows();
        const items = this.dowGridComponent.allItems();

        // Sort rows by instructor name
        ScheduleOnlyGrid.sortRowsAsInstructors(rows);

        // Hide duplicate instructor rows & get index of instructor row
        const uniqueInstructors = new Set<number>();
        const instructorIndex = new Map<number, number>();
        for (const [i, row] of S25Util.array.enumerate(rows)) {
            const instructor = row.data.instructor?.id;
            if (!instructor || uniqueInstructors.has(instructor)) {
                row.hidden = true;
            } else {
                instructorIndex.set(instructor, i);
                uniqueInstructors.add(instructor);
            }
        }

        // Update position of items
        for (const item of items) {
            const index = instructorIndex.get(item.data.instructor?.id);
            item.hidden = (!item.data.instructor || isNaN(index)) && !item.data._isStandardSchedule;
            if (!item.hidden) {
                item.top = (index / rows.length) * 100;
            }
        }

        this.dowGridComponent.addShadows();

        this.dowGridComponent.staticRefresh(this.dowGridComponent.data);
        this.applyFilters();
    }

    toStandardMode() {
        this.dowGridComponent.clearItemFilter(false);
        this.dowGridComponent.clearRowFilter(false);
        const rows = this.dowGridComponent.allRows();
        const items = this.dowGridComponent.allItems();

        // Remove shadows
        this.dowGridComponent.removeShadows();

        // Sort rows by event name
        ScheduleOnlyGrid.sortRowsAsEvents(rows);

        // Un-hide rows & get index of profile row
        const profileIndex = new Map<number, number>();
        for (const [i, row] of S25Util.array.enumerate(rows)) {
            row.hidden = false;
            profileIndex.set(row.data.profileId, i);
        }

        // Update position of items
        for (const item of items) {
            item.hidden = false;
            if (item.data.profileId) {
                item.top = (profileIndex.get(item.data.profileId) / rows.length) * 100;
            }
        }

        this.dowGridComponent.staticRefresh(this.dowGridComponent.data);
        this.applyFilters();
    }

    bringToFront(item: ScheduleOnlyGrid.Item): void {
        this.dowGridComponent.bringToFront(item);
    }

    @Bind
    async checkConflicts() {
        const items = this.dowGridComponent.allItems();
        const conflicts = await this.getConflicts(items, true);
        if (conflicts.error) return;
        this.conflicts = conflicts.data;
        this.dowGridComponent.drawMinimap(); // Update conflict colors
        await this.conflictsModal.open({ templateData: { conflicts: this.conflicts } });
    }

    async getConflicts(
        items: ScheduleOnlyGrid.Item[],
        updateItems: boolean,
    ): Promise<Proto.ResultObj<ScheduleOnlyGrid.Conflicts, boolean>> {
        const instructors = this.checkInstructorConflicts(items, updateItems);
        let locations: ScheduleOnlyGrid.Conflict[] = [];
        let resources: ScheduleOnlyGrid.Conflict[] = [];

        const changedItems = items.filter(ScheduleOnlyGrid.hasItemChanged);
        const availability = await this.checkAvailability(changedItems);
        if (availability.locations.error && availability.resources.error) {
            alert("Something when wrong when checking for conflicts");
        } else if (availability.locations.error) {
            alert("Something went wrong when checking for location conflicts");
        } else if (availability.resources.error) {
            alert("Something went wrong when checking for resource conflicts");
        }
        if (availability.locations.error || availability.resources.error) {
            return { error: true };
        }

        if (updateItems) {
            for (const item of items) {
                item.data.locationConflict.set(false);
                item.data.resourceConflict.set(false);
            }
        }

        const profileToItem = ScheduleOnlyGrid.mapByProfile(changedItems);
        locations = (availability.locations.data || []).map((data) => {
            const item = profileToItem.get(data.ev_dt_profile_id);
            if (updateItems) item.data.locationConflict.set(true);
            const conflict: ScheduleOnlyGrid.Conflict = {
                type: "locationAvailability",
                item,
                time: ScheduleOnlyGrid.getTimeString(item, this.is24Hours),
                load: () => this.loadConflict(conflict),
            };
            return conflict;
        });
        resources = (availability.resources.data || []).map((data) => {
            const item = profileToItem.get(data.ev_dt_profile_id);
            if (updateItems) item.data.resourceConflict.set(true);
            const conflict: ScheduleOnlyGrid.Conflict = {
                type: "resourceAvailability",
                item,
                time: ScheduleOnlyGrid.getTimeString(item, this.is24Hours),
                load: () => this.loadConflict(conflict),
            };
            return conflict;
        });

        const total = instructors.length + locations.length + resources.length;
        const types = Number(!!instructors.length) + Number(!!locations.length) + Number(!!resources.length);
        return { data: { types, total, instructors, locations, resources } };
    }

    checkInstructorConflicts(items: ScheduleOnlyGrid.Item[], updateItems: boolean) {
        const instructors = new Set(items.map((item) => item.data.instructor?.id).filter((id) => id));
        const instructorItems = this.dowGridComponent
            .allItems()
            .filter((item) => instructors.has(item.data.instructor?.id));

        const conflicts: ScheduleOnlyGrid.Conflict[] = this.getInstructorConflicts(instructorItems);

        if (updateItems) {
            for (const item of instructorItems) item.data.instructorConflict.set(false);
            for (const conflict of conflicts) {
                for (const item of conflict.items) {
                    item.data.instructorConflict.set(true);
                }
            }
        }

        return conflicts;
    }

    getInstructorConflicts(items: ScheduleOnlyGrid.Item[]) {
        const conflicts: ScheduleOnlyGrid.Conflict[] = [];

        const byInstructor = S25Util.array.groupBy(items, (item) => item.candidate.instructor?.id);
        for (const instructor of S25Util.values(byInstructor)) {
            instructor.sort((a, b) => a.left - b.left);
            for (const [i, a] of S25Util.array.enumerate(instructor)) {
                if (a.data._isShadow || !a.data.instructor?.id) continue;
                const aDows = new Set(a.candidate.dow.split(""));
                const conflictItems: ScheduleOnlyGrid.Item[] = [];
                for (let j = i + 1; j < instructor.length; j++) {
                    const b = instructor[j];
                    if (b.data._isShadow) continue;
                    if (a.id === b.id || a.candidate.boundProfiles.includes(b.candidate.profileId)) continue;
                    if (!b.candidate.instructor?.id) continue;
                    if (!b.candidate.dow.split("").some((dow) => aDows.has(dow))) continue;
                    if (a.candidate.endHour <= b.candidate.startHour) continue;
                    if (a.candidate.startDate >= b.candidate.endDate || a.candidate.endDate <= b.candidate.startDate)
                        continue;
                    if (!ScheduleOnlyGrid.doOccurrencesOverlap(a.candidate.occurrences, b.candidate.occurrences))
                        continue;

                    conflictItems.push(b);
                }
                if (!conflictItems.length) continue;
                conflicts.push({
                    type: "instructor",
                    item: a,
                    items: [a, ...conflictItems],
                    time: ScheduleOnlyGrid.getTimeString(a, this.is24Hours),
                });
            }
        }

        return conflicts;
    }

    async loadConflict(conflict: ScheduleOnlyGrid.Conflict): Promise<Partial<Conflict>[]> {
        let availPromise: Promise<ResultObj<{ spaces: WSSpacesAvail } & { resources: WSResourcesAvail }>>;
        if (conflict.type === "locationAvailability") {
            const locations = conflict.item.candidate.occurrences.flatMap((occ) =>
                occ.locations.flatMap((loc) => loc.id),
            );
            const dates = conflict.item.candidate.occurrences.map((occ) => ({
                startDt: occ.start,
                endDt: occ.end,
            }));
            availPromise = S25Util.Result(
                SpaceService.getSpaceDatesAvailability(
                    S25Util.array.unique(locations),
                    dates,
                    conflict.item.data.eventId,
                    conflict.item.data.profileId,
                ),
            ) as Promise<ResultObj<{ spaces: WSSpacesAvail } & { resources: WSResourcesAvail }>>;
        } else if (conflict.type === "resourceAvailability") {
            const resources = conflict.item.candidate.occurrences.flatMap((occ) =>
                occ.resources.flatMap((res) => ({
                    itemId: res.id,
                    quantity: res.quantity,
                })),
            );
            const dates = conflict.item.candidate.occurrences.map((occ) => ({
                startDt: S25Util.date.parseDropTZ(occ.start),
                endDt: S25Util.date.parseDropTZ(occ.end),
            }));
            availPromise = S25Util.Result(
                ResourceService.getResourceDatesAvailability(
                    S25Util.array.unique(resources, (res) => res.itemId),
                    dates,
                    conflict.item.data.eventId,
                    conflict.item.data.profileId,
                ),
            ) as Promise<ResultObj<{ spaces: WSSpacesAvail } & { resources: WSResourcesAvail }>>;
        }

        const [resp, fls] = await Promise.all([availPromise, FlsService.getFls()]);
        if (!resp.data || resp.error) {
            alert("Something went wrong when loading conflict");
            return;
        }
        const conflicts: (WSSpaceAvail & WSResourceAvail)[] = S25Util.array.forceArray(
            conflict.type === "locationAvailability" ? resp.data.spaces.space : resp.data.resources.resource,
        );
        return conflicts
            .filter((item) => item.has_conflicts === "T")
            .flatMap((item) =>
                S25Util.array.forceArray(item.dates).flatMap((date) =>
                    S25Util.array.forceArray(date.conflict).map((conflict) => ({
                        isReal: true,
                        candidateDate: S25Util.date.parseDropTZ(date.start_dt),
                        conflictType: conflict.conflict_type,
                        itemName: conflict.conflict_name,
                        conflictName: conflict.conflict_name,
                        conflictShare: conflict.conflict_share === "T",
                        conflictStart: S25Util.date.parseDropTZ(conflict.conflict_start),
                        conflictEnd: S25Util.date.parseDropTZ(conflict.conflict_end),
                        conflictOverride: {
                            blackout: conflict.conflict_type === "blackout" && hasFullFls(fls.SPACE_BLACK),
                            closed: conflict.conflict_type === "hours" && hasFullFls(fls.SPACE_HOURS),
                            block: conflict.conflict_type === "block" && hasFullFls(fls.SPACE_BLOCKED),
                            share:
                                ["rsrv", "block"].includes(conflict.conflict_type) &&
                                !!date.share &&
                                hasFullFls(fls.EVENT_SHARE),
                        },
                    })),
                ),
            );
    }

    @Bind
    async onItemsPickedUp(items: Grid.Item<ScheduleOnlyGrid.ItemData>[]): Promise<boolean> {
        // TODO MULTIPLAYER: Lock item on pick up
        return true;
    }

    @Throttle(300, true)
    onItemsDragged(gridItems: Grid.Item<ScheduleOnlyGrid.ItemData>[]): void {
        const items = gridItems as unknown as ScheduleOnlyGrid.Item[];
        ScheduleOnlyGrid.updateCandidateData(items);
        // TODO MULTIPLAYER: Send update messages
        AriaLive.announce(this.getAriaLiveTime(items[0]), true);
    }

    getAriaLiveTime(item: ScheduleOnlyGrid.Item) {
        const time = S25Util.date.ariaTimeString(S25Util.date.toTimeStrFromHours(item.data.startHour, this.is24Hours));
        return `${time}`;
    }

    @Bind
    async onItemsPutDown(gridItems: Grid.Item<ScheduleOnlyGrid.ItemData>[]): Promise<boolean> {
        let items = gridItems as unknown as ScheduleOnlyGrid.Item[];
        ScheduleOnlyGrid.updateCandidateData(items as ScheduleOnlyGrid.Item[]);

        items = items.filter((item) => ScheduleOnlyGrid.hasItemChanged(item));
        if (items.length === 0) return false;

        const { ok, updateConflicts } = await this.validateItems(items);
        if (!ok) return false;

        if (this.saveType === "individual") {
            const resp = await this.saveItems(items);
            if (!!resp.error) {
                return false; // Return item(s) to previous position
            }
            // TODO MULTIPLAYER: Send message that item moved
        } else if (this.saveType === "bulk") {
            const changes = items.map((item) => {
                return {
                    gridId: this.grid.id,
                    eventId: item.data.eventId,
                    profileId: item.data.profileId,
                    pattern: item.candidate.dow,
                    startTime: `1900-01-01T${S25Util.date.toS25ISOTimeStrFromHours(item.candidate.eventStartHour)}`,
                    endTime: `1900-01-01T${S25Util.date.toS25ISOTimeStrFromHours(item.candidate.eventEndHour)}`,
                };
            });

            const resp = await GridsService.moveItems(this.grid.id, changes);
            if (resp.error) {
                alert(`Something went wrong when moving item${items.length === 1 ? "" : "s"}`);
                return false; // Return item(s) to previous position
            }
        }

        updateConflicts?.();

        // TODO MULTIPLAYER: Unlock on put down
        return true;
    }

    @Bind
    afterItemsMoved(gridItems: Grid.Item<ScheduleOnlyGrid.ItemData>[]): void {
        const items: ScheduleOnlyGrid.Item[] = gridItems as unknown as ScheduleOnlyGrid.Item[];
        this.checkInstructorConflicts(items, true);
    }

    async validateItems(items: ScheduleOnlyGrid.Item[]): Promise<{ ok: boolean; updateConflicts?: () => void }> {
        for (const item of items) {
            const message = this.validateItemPosition(item);
            if (message) {
                alert(message);
                return { ok: false };
            }
        }

        let updateConflicts: () => void;
        if (this.conflictAction !== "none") {
            const itemIds = new Set(items.map((item) => item.id));

            const conflictsResult = await this.getConflicts(items, false);
            if (conflictsResult.error) return { ok: false };
            const conflicts = conflictsResult.data;
            const instructorConflictCount = conflicts.instructors.length;
            conflicts.instructors = conflicts.instructors.filter((conflict) =>
                conflict.items.some((item) => itemIds.has(item.id)),
            );
            conflicts.total += conflicts.instructors.length - instructorConflictCount;

            let type: ModalConfig["type"] = this.conflictAction === "warn" ? "confirm" : "acknowledge";
            // If saving immediately don't allow any location/resource conflicts
            if (this.saveType === "individual" && (conflicts.locations.length || conflicts.resources.length)) {
                type = "acknowledge";
            }
            if (conflicts.total > 0) {
                const ok = await this.confirmConflictsModal.open({ type, templateData: { action: type, conflicts } });
                if (!ok || type === "acknowledge") return { ok: false };
            }

            updateConflicts = () => {
                // If we're going ahead with the move, update conflict info
                const locationConflicts = new Set(conflicts.locations.map((loc) => loc.item.id));
                const resourceConflicts = new Set(conflicts.resources.map((res) => res.item.id));
                for (const item of items) {
                    item.data.locationConflict.set(locationConflicts.has(item.id));
                    item.data.resourceConflict.set(resourceConflicts.has(item.id));
                }
            };
        }

        return { ok: true, updateConflicts };
    }

    validateItemPosition(item: ScheduleOnlyGrid.Item): string {
        // Check AP
        for (const occ of item.candidate.occurrences) {
            const start = S25Util.date.setHours(S25Util.date.parse(occ.start), item.candidate.startHour);
            const end = S25Util.date.setHours(S25Util.date.parse(occ.end), item.candidate.endHour);

            const locationAp = occ.locations.map((loc) => loc.ap);
            const locationPerm = this.checkPerms({ start, end, perms: locationAp, timezone: this.timezone });
            if (occ.locations?.length && !AvailService.isPermEnoughTo("assign", locationPerm)) {
                return `Insufficient perms to assign location(s) to designated time`;
            }

            const resourceAp = occ.resources.map((res) => res.ap);
            const resourcePerm = this.checkPerms({ start, end, perms: resourceAp, timezone: this.timezone });
            if (occ.resources?.length && !AvailService.isPermEnoughTo("assign", resourcePerm)) {
                return `Insufficient perms to assign resource(s) to designated time`;
            }
        }

        return;
    }

    checkPerms(options: { start: Date; end: Date; perms: EventPerm[]; timezone: { instance: string; user: string } }) {
        const finalPerms: Perms[] = options.perms.map((perm) => {
            if (!perm) return { assign: "notSet", unassign: "notSet" };
            return AvailService.coalescePerms(perm, options.start, options.end, options.timezone);
        });
        return AvailService.lowestPerm(finalPerms);
    }

    @Bind
    async downloadConflicts() {
        const instructorConflicts = this.conflicts.instructors.map((conflict) => ({
            Instructor: conflict.item.data.instructor.name,
            "Meeting Pattern": conflict.item.data.dow,
            Time: conflict.time,
            Sections: conflict.items.map((item) => item.data.eventName).join("; "),
        }));
        const sheets: Sheet[] = [{ name: "Instructor Conflicts", data: instructorConflicts }];

        if (this.saveType === "bulk") {
            const locationConflicts = this.conflicts.locations.map((conflict) => ({
                "Meeting Pattern": conflict.item.data.dow,
                Time: conflict.time,
                Section: conflict.item.data.eventName,
            }));

            const resourceConflicts = this.conflicts.resources.map((conflict) => ({
                "Meeting Pattern": conflict.item.data.dow,
                Time: conflict.time,
                Section: conflict.item.data.eventName,
            }));

            sheets.push(
                { name: "Location Conflicts", data: locationConflicts },
                { name: "Resource Conflicts", data: resourceConflicts },
            );
        }

        await SpreadSheetService.downloadExcelMulti(sheets, `${this.grid.name} Conflicts.xlsx`);
    }

    async checkAvailability(
        items: ScheduleOnlyGrid.Item[],
    ): Promise<{ locations: ResultObj<AvailCheckResult[]>; resources: ResultObj<AvailCheckResult[]> }> {
        const locationChecks: SpaceAvailCheck[] = [];
        const resourceChecks: ResourceAvailCheck[] = [];
        for (const item of items) {
            for (const [i, occ] of S25Util.array.enumerate(item?.candidate?.occurrences || [])) {
                const additionalTimeDates = ScheduleOnlyGrid.getOccurrenceDatesWithAdditionalTime(item, occ);
                for (const loc of occ.locations || []) {
                    locationChecks.push({
                        room_id: loc.id,
                        start_dt: additionalTimeDates.start,
                        end_dt: additionalTimeDates.end,
                        event_id: item.data.eventId,
                        ev_dt_profile_id: item.data.profileId,
                        orig_room_id: loc.id,
                        allow_shared: loc.shared,
                        rsrv_id: item.data.original.occurrences[i]?.id ?? -1,
                    });
                }
                for (const res of occ.resources || []) {
                    resourceChecks.push({
                        resource_id: res.id,
                        start_dt: additionalTimeDates.start,
                        end_dt: additionalTimeDates.end,
                        event_id: item.data.eventId,
                        ev_dt_profile_id: item.data.profileId,
                        orig_resource_id: res.id,
                        amount_needed: res.quantity,
                        rsrv_id: item.data.original.occurrences[i]?.id ?? -1,
                    });
                }
            }
        }

        const [locations, resources] = await Promise.all([
            locationChecks.length ? SpaceService.checkAvailability(locationChecks) : { data: [] },
            resourceChecks.length ? ResourceService.checkAvailability(resourceChecks) : { data: [] },
        ]);

        return { locations, resources };
    }

    async saveItems(items: ScheduleOnlyGrid.Item[]) {
        // If we are creating any new occurrences we need new reservation IDs for them
        const missingOccIds = S25Util.array.count(items, (item) => {
            const diff = item.candidate.occurrences.length - item.data.original.occurrences.length;
            return diff <= 0 ? 0 : diff;
        });
        let newOccIds: number[] = [];
        if (missingOccIds > 0) newOccIds = await ReservationService.generateReservationIdsList(missingOccIds);

        const putData = items.map((item) => {
            const original = item.data.original;

            let toRemove: { rsrvId: number }[];
            if (item.candidate.occurrences.length < original.occurrences.length) {
                toRemove = original.occurrences.slice(item.candidate.occurrences.length).map((occ) => ({
                    rsrvId: occ.id,
                }));
            }

            return {
                id: item.data.eventId,
                profiles: [
                    {
                        profileId: item.candidate.profileId,
                        name: item.candidate.profileName,
                        occurrenceDefn: {
                            recTypeId: RecordType.RecurrenceGrammar,
                            profileCode: item.candidate.profileCode,
                            initStartDt: item.candidate.occurrences[0].start,
                            initEndDt: item.candidate.occurrences[0].end,
                        },
                        remove: { reservations: toRemove },
                        reservations: item.candidate.occurrences.map((occ, i) => {
                            const id = original.occurrences[i]?.id;
                            // Moving occurrence
                            if (!!id) {
                                occ.id = id;
                                return { rsrvId: occ.id, evStartDt: occ.start, evEndDt: occ.end };
                            }

                            // Creating occurrence
                            occ.id = newOccIds.pop();
                            return {
                                rsrvId: occ.id,
                                evStartDt: occ.start,
                                evEndDt: occ.end,
                                spaces: occ.locations.map((loc) => ({
                                    spaceId: loc.id,
                                    layoutId: loc.layoutId,
                                    share: loc.shared,
                                    attendance: loc.attendance,
                                })),
                                resources: occ.resources.map((res) => ({
                                    resourceId: res.id,
                                    quantity: res.quantity,
                                })),
                            };
                        }),
                    },
                ],
            };
        }) as EventMircotI[];

        this.isLoading.set(true);
        const result = await EventMicroService.putList(putData);
        this.isLoading.set(false);
        if (!result.error) {
            ScheduleOnlyGrid.updateOriginalsWithCandidates(items);
        }

        // Show any messages/errors
        const error = result.error?.data?.content?.error;
        if (!!result.data?.messages || !!error) {
            const itemByEventId = S25Util.array.mapBy(items, (item) => item.data.eventId);
            const messagesByEvent = S25Util.array.groupBy(result.data?.messages || [], (message) => message.objectId);
            const title = !!result.data?.error ? "Error" : "Warning";
            const messages: ScheduleOnlyGrid.Conflict[] = Object.values(messagesByEvent).map((messages) => {
                const item = itemByEventId.get(messages[0].objectId);
                return {
                    type: "saveMessage",
                    item,
                    time: ScheduleOnlyGrid.getTimeString(item, this.is24Hours),
                    messages: messages.map((message) => message.message),
                };
            });
            let errors: ScheduleOnlyGrid.Conflict[] = [];
            if (!!error) {
                const messages = (error.errors || []).concat(error.messages || []);
                const errorsByEvent = S25Util.array.groupBy(messages, (error) => error.objectId);
                errors = Object.values(errorsByEvent).map((errors) => {
                    const item = itemByEventId.get(errors[0].objectId);
                    return {
                        type: "saveError",
                        item,
                        time: ScheduleOnlyGrid.getTimeString(item, this.is24Hours),
                        message: error.message,
                        messages: errors.map((error) => error.message),
                    };
                });
            }
            await this.saveMessagesModal.open({ title, templateData: { messages, errors } });
        }

        return result;
    }

    @Bind
    async save(): Promise<void> {
        // TODO MULTIPLAYER: Lock
        // Get changes
        const changes = await GridsService.getChanges(this.grid.id);

        if (changes.error) {
            alert("Something went wrong");
            return;
        }
        if (!changes.data?.length) {
            alert("No changes to apply");
            return;
        }

        // Map profile ID to item
        const profileToItem = ScheduleOnlyGrid.mapByProfile(this.dowGridComponent.allItems());

        // Apply changes
        const changedItems: ScheduleOnlyGrid.Item[] = [];
        for (const change of changes.data) {
            const item = profileToItem.get(change.profileId);
            if (!item) continue;
            ScheduleOnlyGrid.applyChange(item, change);
            if (ScheduleOnlyGrid.hasItemChanged(item)) changedItems.push(item);
        }

        // TODO BULK SAVE: Check all conflicts (including instructor)
        // TODO BULK SAVE: Require all location/resource conflicts be resolved
        // TODO BULK SAVE: Ask if they want to continue if only instructor conflicts
        // TODO BULK SAVE: Show errors from service

        // Check availability
        this.checkAvailability(changedItems); // TODO BULK SAVE: Handle conflicts

        this.saveItems(changedItems);

        // TODO BULK SAVE: Telemetry

        await GridsService.clearChanges(this.grid.id);
        this.dowGridComponent.clearHistory();
        // TODO BULK SAVE: Refresh?

        // TODO MULTIPLAYER: Unlock
    }
}
